import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NewslatterspopupComponent } from './Components/newslatterspopup/newslatterspopup.component';
import { ThankyouComponent } from './Components/newslatterspopup/thankyou/thankyou.component';
import { AboutusComponent } from './Pages/aboutus/aboutus.component';
import { AcceptFcInviteFromUserComponent } from './Pages/accept-fc-invite-from-user/accept-fc-invite-from-user.component';
import { AcceptFcInviteComponent } from './Pages/accept-fc-invite/accept-fc-invite.component';
import { AcceptInvitationComponent } from './Pages/accept-invitation/accept-invitation.component';
import { AcceptComponent } from './Pages/accept/accept.component';
import { AffiliatesComponent } from './Pages/affiliates/affiliates.component';
import { CareersComponent } from './Pages/careers/careers.component';
import { CcpaComponent } from './Pages/ccpa/ccpa.component';
import { ContactusComponent } from './Pages/contactus/contactus.component';
import { CostComponent } from './Pages/cost/cost.component';
import { WelcomeComponent } from './Pages/executor-welcome/welcome.component';
import { FamiliesComponent } from './Pages/families/families.component';
import { FaqComponent } from './Pages/faq/faq.component';
import { GdprComponent } from './Pages/gdpr/gdpr.component';
import { IframeComponent } from './Pages/iframe/iframe.component';
import { LoginLandingComponent } from './Pages/login-landing/login-landing.component';
import { PressComponent } from './Pages/press/press.component';
import { PrivacyPolicyComponent } from './Pages/privacy-policy/privacy-policy.component';
import { ReferralsComponent } from './Pages/referrals/referrals.component';
import { SecureFileShareComponent } from './Pages/secure-file-share/secure-file-share.component';
import { SecureLinkAccessComponent } from './Pages/secure-link-access/secure-link-access.component';
import { TermsAndConditionsComponent } from './Pages/terms-and-conditions/terms-and-conditions.component';
import { UnsubscribeComponent } from './Pages/unsubscribe/unsubscribe.component';
import { VerifyEmailComponent } from './Pages/verifyEmail/verifyEmail.component';
import { PcisbuscriptionComponent } from './PciSubScription/pcisbuscription/pcisbuscription.component';
import { InterceptorService } from './Service/interceptor.service';
import { ModuleAuthenticationGuard } from './Service/moduleauthentication.guard';
import { ProfessionalModuleAuthenticationGuard } from './Service/professionalmoduleauthentication.guard';
import { SecureFileAuthenticationGuard } from './Service/secureFileAuthentication.guard';
import { SecureLinkAuthenticationGuard } from './Service/secureLinkAuthentication.guard';
import { ComingSoonGuard } from './marketing/services/coming-soon.guard';
import { UnderConstructionComponent } from './User/Pages/under-construction/under-constructioncomponent';
import { CalendlyComponent } from './Pages/calendly/calendly.component';
import { ProfessionalLandingpageComponent } from './Professional/Pages/professional-landingpage/professional-landingpage.component';
import { ReferafriendComponent } from './Components/referafriend/referafriend.component';
import { PrivacyPolicyMblComponent } from './Pages/privacy-policy-mbl/privacy-policy-mbl.component';
import { TermsAndConditionsMblComponent } from './Pages/terms-and-conditions-mbl/terms-and-conditions-mbl.component';
import { IntroducingFamilyCentralComponent } from './Pages/introducing-family-central/introducing-family-central.component';
import { WelcomeVideoComponent } from './Pages/welcome/welcome.component';
import { WelcomeAdvisorsComponent } from './Pages/welcome-advisors/welcome-advisors.component';
import { LandingAbTestComponent } from './Pages/landing-ab-test/landing-ab-test.component';
import { LandingAbTestV2Component } from './Pages/landing-ab-test-v2/landing-ab-test-v2.component';
import { SignupTypeComponent } from './Pages/signup-type/signup-type.component';

const routes: Routes = [
  // ========== Marketing area (shared chrome via MainLayoutComponent) ==========
  {
    path: '',
    loadComponent: () =>
      import('./marketing/components/main-layout/main-layout.component').then(
        m => m.MainLayoutComponent
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./marketing/pages/home/home.component').then(m => m.MarketingHomeComponent),
        title: 'Family Central — The AI Family Office',
      },
      {
        path: 'how',
        loadComponent: () =>
          import('./marketing/pages/how/how.component').then(m => m.HowComponent),
        title: 'How It Works | Family Central',
      },
      {
        path: 'features',
        loadComponent: () =>
          import('./marketing/pages/features/features.component').then(m => m.FeaturesComponent),
        title: 'Features | Family Central',
      },
      {
        path: 'pricing',
        loadComponent: () =>
          import('./marketing/pages/pricing/pricing.component').then(m => m.PricingComponent),
        title: 'Pricing | Family Central',
      },
      {
        path: 'advisor-program',
        loadComponent: () =>
          import('./marketing/pages/advisor-program/advisor-program.component').then(
            m => m.AdvisorProgramComponent
          ),
        title: 'Advisor Program | Family Central',
      },
      {
        path: 'for-advisors',
        loadComponent: () =>
          import('./marketing/pages/for-advisors/for-advisors.component').then(
            m => m.ForAdvisorsComponent
          ),
        title: 'For Advisors | Family Central',
      },
      {
        path: 'for-service',
        loadComponent: () =>
          import('./marketing/pages/for-service/for-service.component').then(
            m => m.ForServiceComponent
          ),
        title: 'For Armed Forces & First Responders | Family Central',
      },
      {
        path: 'pricing-service',
        loadComponent: () =>
          import('./marketing/pages/pricing-service/pricing-service.component').then(
            m => m.PricingServiceComponent
          ),
        title: 'Service Member Pricing | Family Central',
      },
      {
        path: 'security',
        loadComponent: () =>
          import('./marketing/pages/security/security.component').then(
            m => m.MarketingSecurityComponent
          ),
        title: 'Security | Family Central',
      },
      {
        path: 'team',
        loadComponent: () =>
          import('./marketing/pages/team/team.component').then(m => m.MarketingTeamComponent),
        title: 'Team | Family Central',
      },
      // Legal pages — wrapped in the marketing chrome so they pick up the
      // promo banner, header, view banner, footer, and theme tokens.
      {
        path: 'termsconditions',
        component: TermsAndConditionsComponent,
        title: 'Terms & Conditions | Family Central',
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
        title: 'Privacy Policy | Family Central',
      },
    ],
  },

  // ========== Auth / standalone pages (no chrome) ==========
  {
    path: 'coming-soon',
    loadComponent: () =>
      import('./marketing/pages/coming-soon/coming-soon.component').then(
        m => m.ComingSoonComponent
      ),
    title: 'Coming Soon | Family Central',
  },
  {
    path: 'signin',
    canActivate: [ComingSoonGuard],
    loadComponent: () =>
      import('./marketing/pages/signin/signin.component').then(m => m.MarketingSigninComponent),
    title: 'Sign In | Family Central',
  },
  {
    path: 'signup',
    canActivate: [ComingSoonGuard],
    loadComponent: () =>
      import('./marketing/pages/signup/signup.component').then(m => m.MarketingSignupComponent),
    title: 'Sign Up | Family Central',
  },

  // Legacy aliases
  { path: 'how-it-works', redirectTo: 'how', pathMatch: 'full' },
  { path: 'ourstory', redirectTo: '', pathMatch: 'full' },

  // ========== Existing top-level routes ==========
  { path: 'iframe', component: IframeComponent },
  { path: 'login', component: LoginLandingComponent },
  { path: 'aboutus', component: AboutusComponent },
  { path: 'families', component: FamiliesComponent },
  { path: 'professionals', component: ProfessionalLandingpageComponent },
  { path: 'contactus', component: ContactusComponent },
  { path: 'executoraccept/:id', component: WelcomeComponent },
  { path: 'accept/:id', component: AcceptComponent },
  { path: 'accept-invitation', component: AcceptInvitationComponent },
  { path: 'acceptfcinvite/:id', component: AcceptFcInviteComponent },
  { path: 'acceptfcuserinvite/:id', component: AcceptFcInviteFromUserComponent },
  {
    path: 'questionnaires',
    canActivate: [ComingSoonGuard],
    loadChildren: () =>
      import('./Pages/questionnaires/questionnaires.module').then(
        (m) => m.QuestionnairesModule,
      ),
  },
  {
    path: 'inviteuser/:id',
    loadChildren: () =>
      import('./Pages/questionnaires/questionnaires.module').then(
        (m) => m.QuestionnairesModule,
      ),
  },
  { path: 'verifyemail', component: VerifyEmailComponent },
  { path: 'underconstruction', component: UnderConstructionComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'gdpr', component: GdprComponent },
  { path: 'ccpa', component: CcpaComponent },
  { path: 'careers', component: CareersComponent },
  { path: 'press', component: PressComponent },
  { path: 'referrals', component: ReferralsComponent },
  { path: 'affiliates', component: AffiliatesComponent },
  { path: 'NewsLetterConfirmation/:id', component: ThankyouComponent },
  { path: 'newsletterpopup', component: NewslatterspopupComponent },
  { path: 'pcisubscription', component: PcisbuscriptionComponent },
  { path: 'unsubscribe', component: UnsubscribeComponent },
  { path: 'price-details', component: CostComponent },
  { path: 'book-an-appointment', component: CalendlyComponent },
  { path: 'refer-a-friend', component: ReferafriendComponent },
  { path: 'privacy-policy-app', component: PrivacyPolicyMblComponent },
  { path: 'terms-and-conditions-app', component: TermsAndConditionsMblComponent },
  { path: 'IntroducingFamilyCentral', component: IntroducingFamilyCentralComponent },
  { path: 'Welcome', component: WelcomeVideoComponent },
  { path: 'Welcome_Advisors', component: WelcomeAdvisorsComponent },
  { path: 'home', component: LandingAbTestComponent },
  { path: 'landing', component: LandingAbTestV2Component },
  { path: 'signup-type', component: SignupTypeComponent },
  {
    path: 'pshare/:id',
    component: SecureLinkAccessComponent,
    canActivate: [SecureLinkAuthenticationGuard],
  },
  {
    path: 'upload/:id',
    component: SecureFileShareComponent,
    canActivate: [SecureFileAuthenticationGuard],
  },
  {
    path: 'user',
    loadChildren: () => import('./User/user.module').then((m) => m.UserModule),
    canLoad: [ModuleAuthenticationGuard],
  },
  {
    path: 'executor',
    loadChildren: () =>
      import('./Executor/executor.module').then((m) => m.ExecutorModule),
  },
  {
    path: 'professional',
    loadChildren: () =>
      import('./Professional/professional.module').then(
        (m) => m.ProfessionalModule
      ),
  },
  {
    path: 'authprofessional',
    loadChildren: () =>
      import('./ProfessionalAuth/professionalAuth.module').then(
        (m) => m.ProfessionalAuthModule
      ),
    canLoad: [ProfessionalModuleAuthenticationGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 80],
    }),
  ],
  exports: [RouterModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
  ],
})
export class AppRoutingModule {}
